export const ALLOWED_FILES_DESCRIPTION =
  'PDF, JPEG, JPG and PNG file types are allowed. The maximum file size is 5 MB.';
